import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import GoogleLoginButton from "../components/GoogleLoginButton";

function Inscription() {
  const [role, setRole] = useState("acheteur");
  const [formData, setFormData] = useState({
    nom: "", prenom: "", email: "", telephone: "",
    password: "", confirmPassword: "", entreprise: "",
    wilaya: "", categorie_activite: "", acceptTerms: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (formData.password.length < 6) { setError("Le mot de passe doit contenir au moins 6 caractères"); return; }
    if (formData.password !== formData.confirmPassword) { setError("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await register({ ...formData, role });
      navigate("/mon-espace");
    } catch (err) {
      setError(err.response?.data?.message || "Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: "100%", padding: "12px 15px", border: "1.5px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
  const labelStyle = { display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" };

  const wilayas = ["Alger","Oran","Béjaïa","Annaba","Jijel","Skikda","Tipaza","Mostaganem","Chlef","Aïn Témouchent"];
  const categories = ["Yachts & Voiliers","Bateaux à Moteur","Équipements & Electronique","Sports Nautiques","Services Maritimes","Construction Navale","Divers"];

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f9fafb", padding: "60px 20px" }}>
        <div style={{ backgroundColor: "white", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", width: "100%", maxWidth: "520px" }}>
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>
              Marina<span style={{ color: "#0d9488" }}>DZ</span>
            </h1>
            <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>Créer un compte</h2>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Rejoignez la communauté MarinaDZ</p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <GoogleLoginButton 
              onSuccess={() => navigate("/mon-espace")}
              onError={(msg) => setError(msg || "Erreur Google")}
              label="Se connecter avec Google" 
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
            <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
            <span style={{ fontSize: "13px", color: "#9ca3af" }}>ou créez un compte</span>
            <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
          </div>

          <div style={{ marginBottom: "25px" }}>
            <p style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "12px" }}>Je m'inscris en tant que :</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              {[
                { id: "acheteur", label: "Acheteur", desc: "Je cherche à acheter du matériel maritime" },
                { id: "exposant", label: "Exposant", desc: "Je veux vendre mes produits maritimes" }
              ].map(r => (
                <button key={r.id} type="button" onClick={() => setRole(r.id)}
                  style={{ padding: "16px", border: `2px solid ${role === r.id ? "#0d9488" : "#e5e7eb"}`, borderRadius: "12px", backgroundColor: role === r.id ? "#f0fdfa" : "white", cursor: "pointer", textAlign: "center", fontFamily: "inherit" }}>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: role === r.id ? "#0d9488" : "#1f2937", marginBottom: "4px" }}>{r.label}</div>
                  <div style={{ fontSize: "12px", color: "#6b7280" }}>{r.desc}</div>
                </button>
              ))}
            </div>
          </div>

          {error && (
            <div style={{ backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "12px 15px", marginBottom: "20px", color: "#dc2626", fontSize: "14px" }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "20px" }}>
              <div>
                <label style={labelStyle}>Nom</label>
                <input type="text" name="nom" value={formData.nom} onChange={handleChange} placeholder="Votre nom" required style={inputStyle}
                  onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
              </div>
              <div>
                <label style={labelStyle}>Prénom</label>
                <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} placeholder="Votre prénom" required style={inputStyle}
                  onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Adresse email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="votre@email.com" required style={inputStyle}
                onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Téléphone</label>
              <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="+213 5XX XXX XXX" required style={inputStyle}
                onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
            </div>

            {role === "exposant" && (
              <>
                <div style={{ marginBottom: "20px" }}>
                  <label style={labelStyle}>Nom de l'entreprise</label>
                  <input type="text" name="entreprise" value={formData.entreprise} onChange={handleChange} placeholder="Votre entreprise" required style={inputStyle}
                    onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <label style={labelStyle}>Wilaya</label>
                  <select name="wilaya" value={formData.wilaya} onChange={handleChange} required style={inputStyle}>
                    <option value="">Sélectionner...</option>
                    {wilayas.map(w => <option key={w} value={w}>{w}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <label style={labelStyle}>Catégorie d'activité</label>
                  <select name="categorie_activite" value={formData.categorie_activite} onChange={handleChange} required style={inputStyle}>
                    <option value="">Sélectionner...</option>
                    {categories.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              </>
            )}

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "20px" }}>
              <div>
                <label style={labelStyle}>Mot de passe</label>
                <input type={showPassword ? "text" : "password"} name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required style={inputStyle}
                  onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
              </div>
              <div>
                <label style={labelStyle}>Confirmer</label>
                <input type={showPassword ? "text" : "password"} name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" required style={inputStyle}
                  onFocus={e => e.target.style.borderColor = "#0d9488"} onBlur={e => e.target.style.borderColor = "#e5e7eb"} />
              </div>
            </div>

            <label style={{ display: "flex", alignItems: "flex-start", gap: "10px", fontSize: "14px", color: "#6b7280", marginBottom: "25px", cursor: "pointer" }}>
              <input type="checkbox" name="acceptTerms" checked={formData.acceptTerms} onChange={handleChange} required style={{ accentColor: "#0d9488", marginTop: "3px" }} />
              <span>J'accepte les <Link to="#" style={{ color: "#0d9488", textDecoration: "none" }}>conditions d'utilisation</Link></span>
            </label>

            <button type="submit" disabled={loading}
              style={{ width: "100%", padding: "14px", backgroundColor: loading ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", marginBottom: "20px", fontFamily: "inherit" }}>
              {loading ? "Création en cours..." : `Créer mon compte ${role === "exposant" ? "Exposant" : "Acheteur"}`}
            </button>
          </form>

          <p style={{ textAlign: "center", fontSize: "14px", color: "#6b7280" }}>
            Vous avez déjà un compte ?{" "}
            <Link to="/connexion" style={{ color: "#0d9488", textDecoration: "none", fontWeight: "600" }}>Se connecter</Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Inscription;